import styled from 'styled-components';

export const BannerContainer = styled.div`
  margin: 30px 10px;
`;
